import { Loading, RenderView, usePublicBlockQueryShowBySlug } from "@dgs/core";
import { FC } from "react";
import { useParams } from "react-router";
import { useRegion } from "../region/RegionProvider";
import { useRegistrationToken } from "../shared/hooks/useRegistrationToken";

export const BlockPage: FC = () => {
	const { slug = "" } = useParams();
	const token = useRegistrationToken();
	const { regionId } = useRegion();
	const { block, isLoading } = usePublicBlockQueryShowBySlug(slug, {
		token: token || "",
		regionId: regionId ? `${regionId}` : "",
	});

	if (isLoading) {
		return <Loading />;
	}

	return block ? <RenderView block={block} /> : null;
};
